import { ROUTES } from "../../../module/constants";
import { generalConst } from "../../../module/globalInterface";

export const APPROVALS_URLS: generalConst = {
  BASE_URL: ROUTES.APPROVALS,
  APPROVAL_REQUEST_DETAIL: `${ROUTES.APPROVALS}/ApprovalDetail`,
};

export enum ApprovalOperationType {
  NULL = "NULL",
  APPROVE = "APPROVE",
  REFUSE = "REFUSE",
}

export const APPROVALS_REQUEST_FORM_FILTER = "ApprovalsFormFilter";

export const APPROVALS_IDENTIFIER = "approvals";

export const APPROVALS_LOADER_IDENTIFIER = "approvalsLoader";

export const APPROVALS_CSV_DISABLED = "approvalsCSVLoaded";

export const APPROVALS_CSV_DATA = "approvalsCSVData";

export const SELECTED_APPROVAL_IDENTIFIER = "selectedApproval";

export const APPROVAL_DETAIL_IDENTIFIER = "selectApprovalDetail";

export const APPROVAL_MAIN_CALL_STATE = "approvalMainCallState";

export const ORIGINAL_APPROVAL_LIST_IDENTIFIER = "originalList";

export const TAB_SELECTED_IDENTIFIER = "tabSelected";

export const ATTACHMENT_CALL_STATE_IDENTIFIER = "attachmentCallStateIdentifier";

export const ATTACHMENT_CALL_STATE_IDENTIFIER_SAVE =
  "attachmentCallStateIdentifierSave";
